import STRINGS from './strings'

export const appList = [
  {
    icon: '/assets/images/farmer',
    alt: STRINGS.COMMON.DEHAAT_FARMER_APP,
    appName: STRINGS.COMMON.DEHAAT_FARMER_APP,
    appLink:
      'https://play.google.com/store/apps/details?id=app.intspvt.com.farmer',
  },
  {
    icon: '/assets/images/business-app',
    alt: STRINGS.COMMON.DEHAAT_BUSINESS_APP,
    appName: STRINGS.COMMON.DEHAAT_BUSINESS_APP,
    appLink:
      'https://play.google.com/store/apps/details?id=com.intspvt.app.dehaat2',
  },
]

export const steps = [
  {
    image: '/assets/images/know-your-soil/soil-test',
    imageAlt: STRINGS.KNOW_YOUR_SOIL.SOIL_TEST_ALT,
    description: STRINGS.KNOW_YOUR_SOIL.SOIL_TEST_STEP_DESCRIPTION,
    key: 'step_soil_test',
  },
  {
    image: '/assets/images/know-your-soil/soil-health-card',
    imageAlt: STRINGS.KNOW_YOUR_SOIL.SOIL_HEALTH_CARD_ALT,
    description: STRINGS.KNOW_YOUR_SOIL.SOIL_HEALTH_CARD_STEP_DESCRIPTION,
    key: 'step_soil_health_card',
  },
  {
    image: '/assets/images/know-your-soil/recommend',
    imageAlt: STRINGS.KNOW_YOUR_SOIL.RECOMMENDATION_ALT,
    description: STRINGS.KNOW_YOUR_SOIL.RECOMMENDATION_CARD_STEP_DESCRIPTION,
    key: 'step_recommendation',
  },
]

export const featureItem = [
  {
    image: '/assets/images/know-your-soil/farmer-profile',
    imageAlt: STRINGS.KNOW_YOUR_SOIL.FARMER_PROFILE,
    title: STRINGS.KNOW_YOUR_SOIL.FARMER_PROFILE,
    description: STRINGS.KNOW_YOUR_SOIL.HEALTH_CARD_FARMER_PROFILE,
    key: 'health_card_farmer_profile',
  },
  {
    image: '/assets/images/know-your-soil/soil-profile',
    imageAlt: STRINGS.KNOW_YOUR_SOIL.SOIL_PROFILE,
    title: STRINGS.KNOW_YOUR_SOIL.SOIL_PROFILE,
    description: STRINGS.KNOW_YOUR_SOIL.HEALTH_CARD_SOIL_PROFILE,
    key: 'health_card_soil_profile',
  },
  {
    image: '/assets/images/know-your-soil/crop-recommendation',
    imageAlt: STRINGS.KNOW_YOUR_SOIL.RECOMMENDATIONS,
    title: STRINGS.KNOW_YOUR_SOIL.RECOMMENDATIONS,
    description: STRINGS.KNOW_YOUR_SOIL.HEALTH_CARD_RECOMMENDATIONS,
    key: 'health_card_recommendations',
  },
]
